<template>
    <default-sidebar :active="$store.state.sidebars.showReceiptsEditForm">
        <receipts-edit-form :data="$store.state.sidebars.receiptEditData"
                            v-if="$store.state.sidebars.showReceiptsEditForm && $store.state.sidebars.receiptEditData"/>
    </default-sidebar>
</template>

<script>
    import DefaultSidebar from "./DefaultSidebar";
    import ReceiptsEditForm from "../forms/ReceiptsEditForm";

    export default {
        name: "ReceiptsEditFormSidebar",
        components: {
            DefaultSidebar,
            ReceiptsEditForm,
        },
    }
</script>

<style scoped lang="scss">

</style>
